import { useState, useEffect } from 'react';
import api from '../services/api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PREFIX = 'layout:';

/** The id in a Space's dashboard view ("layout:abc" -> "abc"), or null when the view is not a page layout. */
export const layoutIdOfView = (view) => (typeof view === 'string' && view.startsWith(PREFIX) && view.length > PREFIX.length ? view.slice(PREFIX.length) : null);

/**
 * The page layout with this id, for the home page to draw. `ready` is false until the answer is in; a layout that cannot be had (deleted, or the server could not be reached)
 * comes back as null, and the home page then shows the Default Space's, so a person is never left with nothing.
 */
export const useSpaceLayout = (layoutId) => {
  const [state, setState] = useState({ id: null, layout: null });
  useEffect(() => {
    if (!layoutId) return undefined;
    let cancelled = false;
    api.get(`${API}/nav-header/space-layouts/${layoutId}`)
      .then((res) => { if (!cancelled) setState({ id: layoutId, layout: res.data || null }); })
      .catch(() => { if (!cancelled) setState({ id: layoutId, layout: null }); });
    return () => { cancelled = true; };
  }, [layoutId]);
  if (!layoutId) return { layout: null, ready: true };
  return { layout: state.id === layoutId ? state.layout : null, ready: state.id === layoutId };
};

export default useSpaceLayout;
